import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

@Injectable()
export class HomePageService {

  private http = inject(HttpClient);

  constructor() { }

}
